import { render, staticRenderFns } from "./ParamCategoriaCfop.vue?vue&type=template&id=3818d826"
import script from "./ParamCategoriaCfop.vue?vue&type=script&lang=js"
export * from "./ParamCategoriaCfop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports